import { Directive, ElementRef, forwardRef, HostListener } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { guidValidator, parseGuid } from '@nimbus-library/features/shared/components/material/core';

@Directive({
  selector: '[nimbusGUID][formControlName],[nimbusGUID][formControl],[nimbusGUID][ngModel]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ValidGuidDirective),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ValidGuidDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class ValidGuidDirective implements ControlValueAccessor, Validator {
  private onControlChanged: (value: any) => void;
  private onValidatorChange: () => void;

  private lastValue: string = '';

  public constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  public registerOnChange(fn: any): void {
    this.onControlChanged = fn;
  }

  public registerOnTouched(fn: any): void {}

  public registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  @HostListener('input', ['$event'])
  public onInput(event: KeyboardEvent): void {
    const inputValue: string = (event.target as HTMLInputElement).value || '';
    this.parseValue(inputValue);
  }

  private parseValue(inputValue: string): void {
    let result = parseGuid(inputValue);

    if (this.lastValue.length === result.length && inputValue[inputValue.length - 1] === '-') {
      result += '-';
    }
    this.lastValue = result;
    if (this.onControlChanged) {
      this.onControlChanged(result);
    }
    this.elementRef.nativeElement.value = result;
  }

  public validate(control: AbstractControl): { [key: string]: any } {
    if (!control || !control.value) {
      return null;
    }

    return guidValidator(control);
  }

  public writeValue(value: string): void {
    const inputValue: string = value || '';
    this.parseValue(inputValue);
    if (this.onValidatorChange) {
      this.onValidatorChange();
    }
  }
}
